export { default as withProps } from "./withProps";
export { default as withStaticProps } from "./withStaticProps";
